import Form from "@amzn/awsui-components-react-v3/polaris/form";
import Button from "@amzn/awsui-components-react-v3/polaris/button";
import SpaceBetween from "@amzn/awsui-components-react-v3/polaris/space-between";
import { create_api } from "../utils/constants";
import { useForm } from "react-hook-form";
import { NavigateFunction, useNavigate } from "react-router";
import MiscInfo from "./form_components/MiscInfo";
import AppInfo from "./form_components/AppInfo";
import OwnershipInfo from "./form_components/OwnershipInfo";

export default function ProductIntakeForm(props: any) {
  const navigate: NavigateFunction = useNavigate();
  // TODO: URL checking by pinging the URL because the Regex can only do so much
  // and stripping white spaces and other things
  // add a toggle to select if the submitter is the primary owner or not
  function onClickHandler() {
    navigate("/");
  }

  // useForm hook used for form validation
  const { control, handleSubmit, formState: { errors } } = useForm();

  async function onSubmit(data: any) {

    let request: any;

    request = {};
    request["action"] = "create";
    request["payload"] = data;

    request["payload"]["submitter_alias"] = props.userInfo.alias;
    request["payload"]["submitter_email"] = props.userInfo.email;

    console.log(request);
    // now, we need to strip the nested object structure of primary and secondary aliases
    request.payload.primary_owner_alias = request.payload.primary_owner_alias.value;
    request.payload.secondary_owner_alias = request.payload.secondary_owner_alias.value;

    navigate("/", { state: { submitStatus: "pending" }, replace: true  })
    try {
      const response = await fetch(create_api, {
        mode: 'cors',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'Authorization': props.userInfo.jwt,
        },
        body: JSON.stringify(request)
      });
      // TODO: use react-hook-forms states instead of navigating on 'then'
      // this is a BUG, where it shows success message on faliure
      response.json().then(data => {
        console.log(data);
      }).then(() => navigate("/", { state: { submitStatus: "submitted" }, replace: true }));
    }
    // TODO: Handle the error more gracefully by adding a pop up
    catch (err) {
      console.log(err);
    }
  }

  return (
    <div style={{width :1600}}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={onClickHandler} formAction="none" variant="link">
              Cancel
            </Button>
            <Button variant="primary">Submit</Button>
          </SpaceBetween>
        }
      >
        <SpaceBetween size="l">
           <AppInfo control={control} errors={errors} />
           <OwnershipInfo control={control} errors={errors} jwt={props.userInfo.jwt}/>
           <MiscInfo control={control} errors={errors}/>
        </SpaceBetween>

      </Form>
    </form>
   </div>
  );
}
